const d3 = Object.assign(
    {},
    require("d3-array"),
    require("d3-selection")
)

export function prepareData() {
    const ctx = this
    ctx.objArray = []

    ctx.dataset.forEach(d => {
        // Calculate Coordinates
        let color = ctx.getColor(d, ctx.colorSource)
        let offset = ctx.scaleColor(ctx.getValuefromHex(color, "l"))

        // Create object with basic information which won't change on resize
        let imgObj = {}
        imgObj.id = d.id
        imgObj.color = color
        imgObj.offset = offset
        imgObj.colorPalette = d.colors.palette
        imgObj.url = d.urls.raw
        ctx.objArray.push(imgObj)
    })

}

export default prepareData